import { useState, useEffect } from 'react';
import supabase from '../database/supabaseClient';
import { PostgrestError } from '@supabase/supabase-js'; // Importiere den Typ PostgrestError

const usePlacesList = () => {
  const [hasPlaces, setHasPlaces] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<PostgrestError | null>(null); // Fehlerzustand korrekt typisieren

  useEffect(() => {
    const checkPlaces = async () => {
      try {
        const { data, error } = await supabase
          .from('partner_profile_roles')
          .select('partner_profile_id')
          .limit(1);

        if (error) {
          setError(error); // Setze den Fehlerzustand, wenn ein Fehler auftritt
          console.error(error);
          setLoading(false);
          return;
        }

        setHasPlaces(data && data.length > 0); // Setze den Zustand, wenn Orte vorhanden sind
      } catch (error) {
        setError(error as PostgrestError); // Typen korrekt casten, falls der Fehler ein PostgrestError ist
        console.error(error);
      } finally {
        setLoading(false); // Ladezustand nach der Datenabfrage setzen
      }
    };
    checkPlaces();
  }, []);

  return { hasPlaces, loading, error };
};

export default usePlacesList;
